import React from 'react';
import { 
  Smartphone, 
  Globe, 
  Server, 
  Cloud, 
  Shield, 
  Cpu,
  ArrowRight
} from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Smartphone,
      title: 'Mobile Development',
      description: 'Native and cross-platform mobile applications that deliver exceptional user experiences across iOS and Android devices.',
      features: ['React Native', 'Flutter', 'Native iOS/Android', 'Progressive Web Apps']
    },
    {
      icon: Globe,
      title: 'Web Applications',
      description: 'Scalable, responsive web applications built with modern frameworks and best practices for optimal performance.',
      features: ['React/Next.js', 'Vue/Nuxt', 'Angular', 'Full-stack Solutions']
    },
    {
      icon: Server,
      title: 'Backend Development',
      description: 'Robust server-side solutions with secure APIs, efficient databases, and microservices architecture.',
      features: ['Node.js', 'Python/Django', 'Java/Spring', 'GraphQL/REST APIs']
    },
    {
      icon: Cloud,
      title: 'Cloud Solutions',
      description: 'Cloud-native applications with auto-scaling, high availability, and cost-optimized infrastructure.',
      features: ['AWS/Azure/GCP', 'Kubernetes', 'Serverless', 'DevOps/CI/CD']
    },
    {
      icon: Shield,
      title: 'Security & Compliance',
      description: 'Enterprise-grade security implementations with compliance to industry standards and regulations.',
      features: ['OAuth/JWT', 'Encryption', 'GDPR/HIPAA', 'Security Audits']
    },
    {
      icon: Cpu,
      title: 'AI & Machine Learning',
      description: 'Intelligent applications powered by machine learning models and artificial intelligence.',
      features: ['Natural Language Processing', 'Computer Vision', 'Predictive Analytics', 'ChatGPT Integration']
    }
  ];

  return (
    <section id="services" className="py-20 relative">
      <div className="max-w-7xl mx-auto content-padding">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Our <span className="brand-gradient">Services</span>
          </h2>
          <p className="text-lg text-dark-muted max-w-2xl mx-auto">
            Comprehensive application development services tailored to meet your unique business needs and drive digital transformation.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group relative bg-dark-surface border border-dark-border rounded-xl p-6 hover:border-brand/50 transition-all duration-300 card-lift"
              >
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-brand/5 to-brand-light/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                {/* Content */}
                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-brand/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand/20 transition-colors duration-300">
                    <Icon className="w-7 h-7 text-brand" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold mb-3 group-hover:text-brand transition-colors duration-300">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-dark-muted mb-4 text-sm leading-relaxed">
                    {service.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2 text-sm">
                        <ArrowRight className="w-3 h-3 text-brand flex-shrink-0" />
                        <span className="text-dark-muted">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;

